import { render, staticRenderFns } from "./TaskSetting.vue?vue&type=template&id=33337d3d&scoped=true&"
import script from "./TaskSetting.vue?vue&type=script&lang=js&"
export * from "./TaskSetting.vue?vue&type=script&lang=js&"
import style0 from "./TaskSetting.vue?vue&type=style&index=0&id=33337d3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33337d3d",
  null
  
)

export default component.exports